import { PrimaryAnnotatedType } from '@/components/annotated-type';
import { StoryQuestion, useStoryQuestion } from '@/components/microstory/question';
import { CenteredStoryText } from '@/components/microstory/text';
import { Trans, select, t } from '@lingui/macro';

type AnswerId = keyof GoToSourcesData['primary_sources_for_young_people'];

export function GoToSources2023Chapter3() {
  const answers: {
    id: AnswerId;
    label: string;
  }[] = [
    {
      id: 'hic',
      label: t({
        id: 'go-to-sources-2023.chapter-2.answer-1',
        message: 'High-income countries',
      }),
    },
    {
      id: 'umc',
      label: t({
        id: 'go-to-sources-2023.chapter-2.answer-2',
        message: 'Upper-middle income countries',
      }),
    },
    {
      id: 'lmc',
      label: t({
        id: 'go-to-sources-2023.chapter-2.answer-3',
        message: 'Lower-middle income countries',
      }),
    },
    {
      id: 'lic',
      label: t({
        id: 'go-to-sources-2023.chapter-2.answer-4',
        message: 'Low-income countries',
      }),
    },
  ];

  const { selectedAnswer, handleAnswer } = useStoryQuestion<(typeof answers)[number]>();

  return (
    <>
      <StoryQuestion
        question={t({
          message: 'Where generational differences largest for information sources?',
          id: 'go-to-sources-2023.chapter-3.question',
        })}
        answers={answers}
        selectedAnswer={selectedAnswer}
        response={
          selectedAnswer?.id &&
          t({
            id: `go-to-sources-2023.chapter-2.question.response`,
            message: select(selectedAnswer.id, {
              hic: 'Afraid not!',
              umc: "That's right!",
              lmc: 'Afraid not!',
              lic: 'Afraid not!',
            }),
          })
        }
        onAnswer={handleAnswer}
      />

      <CenteredStoryText>
        <Trans id="go-to-sources-2023.chapter-3.text-1">
          The sharpest divide is in{' '}
          <PrimaryAnnotatedType>upper-middle-income countries</PrimaryAnnotatedType> – where 15-24
          year-olds are more than seven times more likely to rely on social media platforms for
          information than people aged 65+.
        </Trans>
      </CenteredStoryText>

      <CenteredStoryText>
        <Trans id="go-to-sources-2023.chapter-3.text-2">
          In countries where there’s widespread digital access but an anemic web presence for
          traditional new sources, social media fills the void for the young.
        </Trans>
      </CenteredStoryText>
    </>
  );
}
